define('ProductDetails.Downloads.View', [
  'Backbone',
  'ItemPDF.Model',
  'product_details_downloads.tpl',
  'underscore'
], function defineProductDetailsDownloadsView(
  Backbone,
  ItemPDFModel,
  product_details_downloads_tpl,
  _
) {
  'use strict';

  return Backbone.View.extend({
    template: product_details_downloads_tpl,

    initialize: function (options) {
      this.model = options.model || new ItemPDFModel();

      this.once('beforeViewRender', this.fetchAndRender, this);
    },

    fetchAndRender: function () {
      var self = this;
      var pdp = SC.Application.getComponent('PDP');

      this.model
        .fetch({
          data: {
            itemId: pdp.getItemInfo().item.internalid
          }
        })
        .done(function () {
          self.render();
        });
    },

    getContext: function () {
      return {
        pdfs: this.model.get('pdfs')
      };
    }
  });
});
